import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { getPageName, getUiInterface, getSuccessMessage, getErrorMessage } from "../../../locales/translationUtils";
import { useTranslation } from 'react-i18next';
import NavBar, { NavBarItem } from "../../../components/NavBar";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useRelease } from "../../../apis/release/ReleaseProvider";

const ViewShipInfoById: React.FC = () => {
    const { t } = useTranslation();
    const [alert, setAlert] = useState<{ id: string }>();
    const { id } = useParams<{ id: string }>();
    const { fetchReleaseById, release } = useRelease();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const navItems: NavBarItem[] = [
        { label: t('shipInfo.labels.home'), route: "/", iconName: "house-door" },
    ];

    useEffect(() => {
        if (!id) throw new Error("ID inválido");

        const loadRelease = async () => {
            try {
                setLoading(true);
                setError(false);

                if (!id) throw new Error("ID inválido");

                fetchReleaseById(Number(id));
 
            } catch (err) {
                console.error("Erro ao carregar os dados:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        loadRelease();
    }, [id, fetchReleaseById]);

    const cargosColumns: GridColDef[] = [
        { 
            field: "supplier", 
            headerName: t('shipInfo.fields.supplier'), 
            width: 350,
            valueGetter: (supplier: any) => {
                return supplier?.name
            } 
        },
        { field: "dawb", headerName: t('shipInfo.fields.dawb'), width: 350,},
        { field: "wrNumber", headerName: t('shipInfo.fields.wrNumber'), width: 350 },
        { 
            field: "carrierInformations", 
            headerName: t('shipInfo.fields.invoice'), 
            width: 350,
            valueGetter: (carrierInformations: any) => {
                return carrierInformations[0]?.invoice
            } 
        },
    ];

    const handleReturnPage = () => {
        navigate(`/shipinfo`);
    };

    if (loading) {
        return <div className="text-center mt-4">Carregando...</div>;
    }

    if (error || !release) {
        return <div className="text-center mt-4 text-danger">Erro ao carregar os dados.</div>;
    }

    return (
        <Container fluid>
            <NavBar items={navItems} />

            <div className="mb-3"></div>
            <h2>{getPageName("viewRelease")}</h2>

            <Form className="mt-3">
                <Row>
                    <Col md={4} className="mb-3">
                        <Form.Group>
                            <Form.Label>{t('shipInfo.fields.id')}</Form.Label>
                            <Form.Control size="sm" readOnly value={release.id} style={{ width: "100%", backgroundColor: "#f0f0f0" }} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={4} className="mb-3">
                        <Form.Group controlId="shippedBy">
                            <Form.Label>{t('shipInfo.fields.carrier')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="shippedBy"
                                value={release.shippedBy}
                                readOnly={true}
                                style={{ width: "100%", backgroundColor: "#f0f0f0" }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                        <Form.Group controlId="destination">
                            <Form.Label>{t('shipInfo.fields.destination')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="destination"
                                value={release.destination?.description}
                                readOnly={true}
                                style={{ width: "100%", backgroundColor: "#f0f0f0" }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                        <Form.Group controlId="freightType">
                            <Form.Label>{t('shipInfo.fields.status')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="freightType"
                                value={release.freightType?.description}
                                readOnly={true}
                                style={{ width: "100%", backgroundColor: "#f0f0f0" }}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={4} className="mb-3">
                        <Form.Group controlId="releasedBy">
                            <Form.Label>{t('shipInfo.fields.carrier')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="releasedBy"
                                value={release.releasedBy?.username}
                                readOnly={true}
                                style={{ width: "100%", backgroundColor: "#f0f0f0" }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                        <Form.Group controlId="consignee">
                            <Form.Label>{t('shipInfo.fields.carrier')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="consignee"
                                value={release.consignee?.name}
                                readOnly={true}
                                style={{ width: "100%", backgroundColor: "#f0f0f0" }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                        <Form.Group controlId="tc">
                            <Form.Label>{t('shipInfo.fields.trackingNumber')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="tc"
                                value={release.tc}
                                readOnly={true}
                                style={{ width: "100%", backgroundColor: "#f0f0f0" }}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={4} className="mb-3">
                        <Form.Group controlId="to">
                            <Form.Label>{t('shipInfo.fields.destination')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="to"
                                value={release.to?.name}
                                readOnly={true}
                                style={{ width: "100%", backgroundColor: "#f0f0f0" }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                        <Form.Group controlId="released">
                            <Form.Label>{t('shipInfo.fields.shipmentDate')}</Form.Label>
                            <Form.Control
                                type="date"
                                name="released"
                                value={release.released?.toString().split('T')[0]}
                                readOnly={true}
                                style={{ width: "100%", backgroundColor: "#f0f0f0" }}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <h6>{t('shipInfo.labels.cargos')}</h6>
                    <Col md={12} className="mb-3">
                        <DataGrid
                            rows={release.cargos}
                            columns={cargosColumns}
                            checkboxSelection={false}
                            getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row")}
                            sx={{
                                    "& .MuiDataGrid-row:nth-of-type(even)": {
                                    backgroundColor: "#f5f5f5",
                                    },
                                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                                    backgroundColor: "white",
                                    },
                                    "& .MuiDataGrid-row:hover": {
                                    backgroundColor: "#b2d1ff",
                                },
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "14px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "14px",
                                },
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="mb-3">
                        <Form.Group controlId="obs">
                            <Form.Label>Obs</Form.Label>
                            <Form.Control
                                type="text"
                                name="obs"
                                value={release.obs}
                                readOnly={true}
                                style={{ width: "100%", backgroundColor: "#f0f0f0" }}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                
            </Form>
            <div className="mt-3 mb-3 d-flex gap-2">
                <Button variant="danger" className="w-20" onClick={handleReturnPage}>
                    {getUiInterface("return")}
                </Button>
            </div>
        </Container>
    );
};

export default ViewShipInfoById;
